module.exports = __webpack_public_path__ + "img/4a9106e2397d4c193eca0eeb62f3f5a0.png";